import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_members_are_in_the_bipartite_committee'

export const dataPointDefinition = {
  retracedId: 'how_many_members_are_in_the_bipartite_committee',
  name: 'How many members are in the bipartite committee?',
  description:
    'If there are multiple bipartite committees, include information on the committee that is in place to support social dialogue in the facility. Otherwise, include information on the largest committee.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-wor-5',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12690,
  sectionId: '2.2.10.2',
  impactArea: 'Workplace Cooperation',
  impactAreaId: 'WORKPLACE_COOPERATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
